module.exports = __webpack_public_path__ + "img/shiyong.eb8b3ff0.png";